import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../Shared/Loader';
import { useRef } from 'react';
import AddPurchaseProductList from './AddPurchaseProductList';
import AddPurchaseInvoice from './AddPurchaseInvoice';
import { addUpdateDetails, selectSupplier } from '../../../../features/PurchaseSlice/PurchaseSlice';
import SupplierList from '../../../../hooks/SupplierList';
import { Link, useLocation } from 'react-router-dom';
import { FiArrowLeft, FiCalendar, FiCornerUpLeft, FiTruck } from 'react-icons/fi';
import '../../Sales/AddSales/MobileDefaultSales.css';


const PurchaseReturnInvoice = () => {
    const { posSupplier, isSupplier } = useSelector((state) => state.purchaseInvoice);
    const supply = useSelector((state) => state.purchaseInvoice.supplier);
    const [isSearching, setIsSearching] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [searchText, setSearchText] = useState([]);
    const [loading, setLoading] = useState(true);
    const [suppliers, setSuppliers] = useState([]);
    // const [details, setDetails] = useState();
    const [defaultSupplier, setDefaultSupplier] = useState(false);
    const [isChangeDate, setIsChangeDate] = useState(false);

    const { returnPurchase } = useSelector((state) => state.purchaseInvoice);

    console.log(returnPurchase);

    const supplierCodeRef = useRef('');
    const supplierRef = useRef('');
    const dateRef = useRef('');
    const addressRef = useRef('');
    const phoneRef = useRef('');
    const openingRef = useRef('');
    const invoiceRef = useRef('');

    const dispatch = useDispatch();
    const location = useLocation();
    const isMobileReturn = location.pathname.startsWith('/mobile/');



    useEffect(() => {
        fetch('https://servers.thakurgaonexpress.com/rupkotha/getsuppliers')
            .then(res => res.json())
            .then(data => {
                setSuppliers(data);
                setLoading(false)
            })
    }, [])


    if (loading) {
        return <Loader />
    }

    const handleSearchResult = (event) => {
        setSearchText(event.target.value)
        const match = suppliers.filter(supplier => supplier.name.includes(searchText)
            || supplier.name.toLowerCase().includes(searchText) ||
            supplier.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const handleSelectSupplier = (suppliar) => {
        dispatch(selectSupplier(suppliar))
        setIsSearching(false)
        setSearchText('');
        setDefaultSupplier(true)

        setTimeout(() => { handlePurchaseDetails() }, 2000);
        // const purchaseInvoice = invoiceRef.current.value;
        // const purchaseSupplier = supplierRef.current.innerText;
        // const purchaseAddress = addressRef.current.innerText;
        // const purchasePhone = phoneRef.current.innerText;
        // const purchaseOpening = openingRef.current.innerText;
        // const purchaseDate = dateRef.current.value;
        // dispatch(addUpdateDetails({ purchaseInvoice, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseDate }))

    }


    const handlePurchaseDetails = (event) => {
        const purchaseInvoice = invoiceRef.current.value;
        const supplierCode = supplierCodeRef.current.innerText;
        const purchaseSupplier = supplierRef.current.innerText;
        const purchaseAddress = addressRef.current.innerText;
        const purchasePhone = phoneRef.current.innerText;
        const purchaseOpening = openingRef.current.innerText;
        const purchaseReturnDate = dateRef.current.value;
        // setDetails({ purchaseInvoice, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseDate })
        dispatch(addUpdateDetails({ purchaseInvoice, supplierCode, purchaseSupplier, purchaseAddress, purchasePhone, purchaseOpening, purchaseReturnDate }))
        setIsChangeDate(true);
    }


    if (isMobileReturn) {
        return <div className="mobile-sale-checkout mobile-purchase-checkout mobile-return-checkout"><header className="mobile-sale-checkout__hero"><div><p className="mobile-sale-checkout__eyebrow"><FiCornerUpLeft />Touch purchase return</p><h1>Return purchase</h1><p>Invoice {returnPurchase?.purchaseInvoice || '—'}</p></div><Link className="mobile-sale-checkout__home" to="/mobile/managereturnpurchase" aria-label="Back to purchase returns"><FiArrowLeft /></Link></header><section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiTruck />Supplier</h2><small>Original purchase supplier</small></div><div className="mobile-sale-checkout__customer-summary"><div className="mobile-sale-checkout__customer-card"><small>Supplier</small><strong ref={supplierRef}>{isSupplier ? posSupplier?.name : returnPurchase?.purchaseSupplier}</strong><span><span ref={supplierCodeRef}>{isSupplier ? posSupplier?.code : returnPurchase?.supplierCode}</span> · <span ref={phoneRef}>{isSupplier ? posSupplier?.phone : returnPurchase?.purchasePhone}</span></span><span ref={addressRef} className="hidden">{isSupplier ? posSupplier?.address : returnPurchase?.purchaseAddress}</span></div><div className="mobile-sale-checkout__due-card"><small>Previous due</small><strong ref={openingRef}>{Number(isSupplier ? posSupplier?.opening : returnPurchase?.purchaseOpening || 0).toFixed(2)}</strong></div></div></section><section className="mobile-sale-checkout__section"><div className="mobile-sale-checkout__section-head"><h2><FiCalendar />Return details</h2><small>Review before return</small></div><div className="mobile-sale-checkout__meta-grid"><div className="mobile-sale-checkout__field"><label>Return date</label><input onChange={handlePurchaseDetails} ref={dateRef} type="date" defaultValue={returnPurchase?.purchaseDate} /></div><div className="mobile-sale-checkout__field"><label>Invoice number</label><input onChange={handlePurchaseDetails} ref={invoiceRef} type="text" defaultValue={returnPurchase?.purchaseInvoice} /></div></div></section><section className="mobile-sale-checkout__section mobile-default-sale-checkout__products"><div className="mobile-sale-checkout__section-head"><h2>Returned products</h2><small>Choose products and confirm amounts</small></div><AddPurchaseProductList /><AddPurchaseInvoice isChangeDate={isChangeDate} /></section></div>;
    }
    return (
        <div>
            <div className='w-full px-5 pb-5 my-5 text-xs'>
                <h1 className='text-lg text-center bg-primary p-3 text-white rounded-xl'>Return A Purchase</h1>
                <div className='grid grid-cols-1 lg:grid-cols-12 gap-px'>
                    <div className='lg:col-span-4 mt-4'>
                        <table class="table w-1/2 mx-auto">
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Select Date</th>
                                    <th className='bg-primary text-white normal-case'>Invoice No</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className=''>
                                    <td><input onChange={handlePurchaseDetails} ref={dateRef} type="date" defaultValue={returnPurchase?.purchaseDate} className='rounded-lg bg-gray-200 p-3  text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                                    <td><input onChange={handlePurchaseDetails} ref={invoiceRef} type="text" defaultValue={returnPurchase?.purchaseInvoice} className='rounded-lg bg-gray-200 p-3 w-40 text-center placeholder-gray-400 focus:border-blue-500 focus:bg-white focus:outline-none w-full max-w-xs' /></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    {/* <div class="form-control w-full lg:w-60 max-w-xs mt-5 col-span-2">
                        <div class="form-control lg:w-60 mx-auto">
                            {/* <input onChange={handleSearchResult} value={searchText} type="text" placeholder="Search Supplier" class="rounded-lg bg-gray-300 text-textPrimary p-3 text-white text-center focus:border-blue-500 focus:outline-none w-full max-w-xs" />
                        </div>
                        <div style={isSearching ? {} : { visibility: 'hidden' }} className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 bg-gray-200 p-2 ${isSearching ? 'h-16' : "h-8"} w-80 overflow-auto`}>
                            {
                                isSearching ? searchResult.map(supplier =>
                                    <label for="update-modal" onClick={() => handleSelectSupplier(supplier)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{supplier?.name}</label>) :
                                    suppliers.map(supplier =>
                                        <label for="update-modal" onClick={() => handleSelectSupplier(supplier)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{supplier?.name}</label>)
                            } */}
                    {/* <SupplierList handlePurchaseDetails={handlePurchaseDetails} suppliers={suppliers} /> */}
                    {/* </div> */}
                    {/* </div> */}
                    <div className='lg:col-span-6 mt-4 overflow-auto lg:lg:overflow-visible'>
                        <table class="table lg:w-1/2 lg:ml-2">
                            <thead className='text-center'>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>Supplier Code</th>
                                    <th className='bg-primary text-white normal-case'>Supplier Name</th>
                                    <th className='bg-primary text-white normal-case'>Supplier Address</th>
                                    <th className='bg-primary text-white normal-case'>Mobile No</th>
                                    <th className='bg-primary text-white normal-case'>Previews Due</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr className=''>
                                    <td ref={supplierCodeRef}>{isSupplier === true ? posSupplier?.code : returnPurchase?.supplierCode}</td>
                                    <td onChange={handlePurchaseDetails} ref={supplierRef} className='h-8'>{isSupplier === true ? posSupplier?.name : returnPurchase?.purchaseSupplier}</td>
                                    <td ref={addressRef}>{isSupplier === true ? posSupplier?.address : returnPurchase?.purchaseAddress}</td>
                                    <td ref={phoneRef}>{isSupplier === true ? posSupplier?.phone : returnPurchase?.purchasePhone}</td>
                                    <td ref={openingRef}>{isSupplier === true ? posSupplier?.opening : returnPurchase?.purchaseOpening}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <br />
                </div>
                <div className='grid grid-cols-1 relative'>
                    <AddPurchaseProductList />
                    <AddPurchaseInvoice isChangeDate={isChangeDate} />
                </div>
            </div>
        </div>
    );
};

export default PurchaseReturnInvoice;
